import {CountryBlock, CountryBlockType} from '../blocks/CountryBlock'
import {CtaBlock, CtaBlockType} from '../blocks/CtaBlock'
import {CtaGiftBlock, CtaGiftBlockType} from '../blocks/CtaGiftBlock'
import {CtaPreviewBlock, CtaPreviewBlockType} from '../blocks/CtaPreviewBlock'
import {DownloadsBlock, DownloadsBlockType} from '../blocks/DownloadsBlock'
import {ImagesBlock, ImagesBlockType} from '../blocks/ImagesBlock'
import {PartnersBlock, PartnersBlockType} from '../blocks/PartnersBlock'
import {PersonBlock, PersonBlockType} from '../blocks/PersonBlock'
import {RouteBlock, RouteBlockType} from '../blocks/RouteBlock'
import {SidebarContact, SidebarContactType} from './SidebarContact'
import {SidebarPrintdemand, SidebarPrintdemandType} from './SidebarPrintdemand'
import {SidebarSizechart, SidebarSizechartType} from './SidebarSizechart'
import {TextBlock, TextBlockType} from '../blocks/TextBlock'
import {VideoBlock, VideoBlockType} from '../blocks/VideoBlock'

import {LineBlock} from '../blocks/Blocks'
import React from 'react'
import {style} from '../../util/style'

const styles = style('sidebarblocks')

export type SidebarBlockType =
	| {type: 'line'}
	| ({type: 'text'} & TextBlockType)
	| ({type: 'images'} & ImagesBlockType)
	| ({type: 'cta'} & CtaBlockType)
	| ({type: 'ctapreview'} & CtaPreviewBlockType)
	| ({type: 'ctagift'} & CtaGiftBlockType)
	| ({type: 'sizechart'} & SidebarSizechartType)
	| ({type: 'printdemand'} & SidebarPrintdemandType)
	| ({type: 'contact'} & SidebarContactType)
	| ({type: 'person'} & PersonBlockType)
	| ({type: 'partners'} & PartnersBlockType)
	| ({type: 'video'} & VideoBlockType)
	| ({type: 'route'} & RouteBlockType)
	| ({type: 'downloads'} & DownloadsBlockType)
	| ({type: 'country'} & CountryBlockType)
	| {type: 'custom'; render: () => any}

export const SidebarBlocks: React.FC<{
	blocks: Array<SidebarBlockType>
}> = ({blocks}) => {
	if (!blocks || blocks.length === 0) return null

	return (
		<div className={styles()}>
			{blocks.map((block) => {
				switch (block.type) {
					case 'line':
						return <LineBlock sidebar={true} />
					case 'text':
						return <TextBlock {...block} sidebar={true} />
					case 'images':
						return <ImagesBlock {...block} sidebar={true} />
					case 'cta':
						return <CtaBlock {...block} sidebar={true} />
					case 'ctapreview':
						return <CtaPreviewBlock {...block} sidebar={true} />
					case 'ctagift':
						return <CtaGiftBlock {...block} sidebar={true} />
					case 'sizechart':
						return <SidebarSizechart {...block} />
					case 'printdemand':
						return <SidebarPrintdemand {...block} />
					case 'contact':
						return <SidebarContact {...block} />
					case 'person':
						return <PersonBlock {...block} sidebar={true} />
					case 'partners':
						return <PartnersBlock {...block} sidebar={true} />
					case 'video':
						return <VideoBlock {...block} />
					case 'route':
						return <RouteBlock {...block} sidebar={true} />
					case 'downloads':
						return <DownloadsBlock {...block} sidebar={true} />
					case 'country':
						return <CountryBlock {...block} sidebar={true} />
					case 'custom':
						return block.render()
					default:
						return <p>Unknown block type: {(block as any).type}</p>
				}
			})}
		</div>
	)
}
